import React from 'react';
import Sorter from './component';

export default React.memo(Sorter);
